// packages/app/src/scaffolder/serviceKeyValidation.ts
//
// Mirrors packages/backend/src/modules/scaffolder/validation.ts's
// validateServiceKey exactly (same charset, same 6-char minimum, same
// 47/5 length constants). There is no shared package between packages/app and
// packages/backend, so this is a deliberate duplicate — keep the two in sync,
// the way packages/app/src/utils/eksTeam.ts mirrors
// packages/backend/src/modules/permission/permissionPolicyModule.ts.
//
// serviceKey combines with appKey into a Bitbucket repo suffix
// ({appKey}-{serviceKey}) that must stay within Bitbucket's 48-char slug
// limit, so the max length shrinks as appKey grows.

export const ENTITY_KEY_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const SERVICE_KEY_MIN_LENGTH = 6;
export const SERVICE_KEY_REPO_SUFFIX_MAX = 47;

export function serviceKeyMaxLength(appKey: string): number {
  return 1 + Math.max(5, SERVICE_KEY_REPO_SUFFIX_MAX - appKey.length);
}

/**
 * Validates serviceKey against the same rule as the backend's
 * validateServiceKey(serviceKey, appKey). Returns an error message string, or
 * null if valid.
 */
export function validateServiceKey(serviceKey: string, appKey: string): string | null {
  if (!serviceKey) return null; // let "required" handle empty

  if (!ENTITY_KEY_PATTERN.test(serviceKey)) {
    return 'Only lowercase letters, numbers, and single hyphens allowed (no leading, trailing, or consecutive hyphens).';
  }

  const maxLength = serviceKeyMaxLength(appKey);

  if (serviceKey.length < SERVICE_KEY_MIN_LENGTH) {
    return `Service key must be at least ${SERVICE_KEY_MIN_LENGTH} characters.`;
  }

  if (serviceKey.length > maxLength) {
    return appKey
      ? `Service key too long. With app key "${appKey}" (${appKey.length} chars), max is ${maxLength} chars.`
      : `Service key must be at most ${maxLength} characters.`;
  }

  return null;
}
